import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Labels } from '../app.models';

@Component({
  selector: 'app-fraud-warning',
  templateUrl: './fraud-warning.component.html',
  styleUrls: ['./fraud-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FraudWarningComponent {
  @Output() public next: EventEmitter<void> = new EventEmitter<void>();

  private _labels: Labels;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
  }

  public get labels() {
    return this._labels;
  }

  constructor() {}
}
